import BigNumber from 'bignumber.js';
import React, { createContext, useContext, useEffect, useState } from 'react';

import { useOpenLimitOrderParamsUpdate } from '../TradeModuleConfirm/hooks/useOpenLimitOrderParams';
import { useOpenMarketTradeParamsUpdate } from '../TradeModuleConfirm/hooks/useOpenMarketTradeParams';
import { useCalcEstOpenLimitGasFee } from './ctx/useCalcEstOpenLimitGasFee';
import { useCalcEstOpenPositionGasFee } from './ctx/useCalcEstOpenPositionGasFee';
import { useCalcOpenPositionFee } from './ctx/useCalcOpenPositionFee';
import { useNewCollateralInputValidation } from './ctx/useNewCollateralInputValidation';
import { useIsConfirmBtnDisabledUpdate } from './hooks/confirmBtnDisabled/useIsConfirmBtnDisabledUpdate';
import { useTotalOpenPositionFeeUpdate } from './hooks/useTotalOpenPositionFee';
import { TradeModuleContext } from './TradeModuleCtx';

const Update = () => {
    useIsConfirmBtnDisabledUpdate();
    useTotalOpenPositionFeeUpdate();
    useOpenLimitOrderParamsUpdate();
    useOpenMarketTradeParamsUpdate();

    return null;
}

export const TradeModuleProvider: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const collateralAmountValidation = useNewCollateralInputValidation();
    const openPositionFee = useCalcOpenPositionFee();
    const { gas: openPositionGasFee } = useCalcEstOpenPositionGasFee();
    const { gas: openLimitGasFee } = useCalcEstOpenLimitGasFee();

    return (
        <TradeModuleContext.Provider value={{
            collateralAmountValidation,
            openPositionFee,
            openPositionGasFee,
            openLimitGasFee,
        }}>
            <Update />
            {children}
        </TradeModuleContext.Provider>
    );
};